// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "12-pairs-seibertron-s-flexible-06-tpr-oilfield-safety-work-construction-industrial-protective-anti-cut-resistant-impact-mechanic-gloves",
  "entries": [
    {
      "id": "28647129809086",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/12-pairs-Seibertron-S-Flexible-06-TPR-Oilfield-Safety-Work-Safety-Gloves-Construction-Industrial-Protective-Anti-Cut-Resistant-Impact-Mechanic-Gloves-Seibertron-28647129809086.jpg?v=1769482292",
      "alt": "safety gloves"
    },
    {
      "id": "28796730671294",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/12-pairs-Seibertron-S-Flexible-06-TPR-Oilfield-Safety-Work-Safety-Gloves-Construction-Industrial-Protective-Anti-Cut-Resistant-Impact-Mechanic-Gloves-Seibertron-28796730671294.jpg?v=1769482292",
      "alt": "Industrial work gloves with impact protection for mechanical tasks"
    },
    {
      "id": "28796730704062",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/12-pairs-Seibertron-S-Flexible-06-TPR-Oilfield-Safety-Work-Safety-Gloves-Construction-Industrial-Protective-Anti-Cut-Resistant-Impact-Mechanic-Gloves-Seibertron-28796730704062.jpg?v=1769482292",
      "alt": "Industrial work gloves with impact protection for mechanical tasks"
    },
    {
      "id": "28796730736830",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/12-pairs-Seibertron-S-Flexible-06-TPR-Oilfield-Safety-Work-Safety-Gloves-Construction-Industrial-Protective-Anti-Cut-Resistant-Impact-Mechanic-Gloves-Seibertron-28796730736830.jpg?v=1769482292",
      "alt": "Professional mechanic gloves offering impact protection during repairs"
    },
    {
      "id": "28796730769598",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/12-pairs-Seibertron-S-Flexible-06-TPR-Oilfield-Safety-Work-Safety-Gloves-Construction-Industrial-Protective-Anti-Cut-Resistant-Impact-Mechanic-Gloves-Seibertron-28796730769598.jpg?v=1769482292",
      "alt": "Heavy duty mechanic gloves with impact resistant design"
    },
    {
      "id": "28796730802366",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/12-pairs-Seibertron-S-Flexible-06-TPR-Oilfield-Safety-Work-Safety-Gloves-Construction-Industrial-Protective-Anti-Cut-Resistant-Impact-Mechanic-Gloves-Seibertron-28796730802366.jpg?v=1769482292",
      "alt": "Automotive mechanic gloves designed to reduce impact injuries"
    },
    {
      "id": "28796730835134",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/12-pairs-Seibertron-S-Flexible-06-TPR-Oilfield-Safety-Work-Safety-Gloves-Construction-Industrial-Protective-Anti-Cut-Resistant-Impact-Mechanic-Gloves-Seibertron-28796730835134.jpg?v=1769482292",
      "alt": "Mechanic gloves featuring impact protection for hands and knuckles"
    },
    {
      "id": "28796730867902",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/12-pairs-Seibertron-S-Flexible-06-TPR-Oilfield-Safety-Work-Safety-Gloves-Construction-Industrial-Protective-Anti-Cut-Resistant-Impact-Mechanic-Gloves-Seibertron-28796730867902.png?v=1769482292",
      "alt": "Impact mechanic gloves with reinforced knuckle protection for automotive work"
    },
    {
      "id": "28796730933438",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/12-pairs-seibertron-s-flexible-06-tpr-oilfield-safety-work-construction-industrial-protective-anti-cut-resistant-impact-mechanic-gloves-605956.jpg?v=1734301545",
      "alt": "12 pairs Seibertron S - Flexible 06 TPR Oilfield Safety Work Construction Industrial Protective Anti Cut Resistant Impact Mechanic Gloves - Seibertron"
    },
    {
      "id": "28796730998974",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/12-pairs-seibertron-s-flexible-06-tpr-oilfield-safety-work-construction-industrial-protective-anti-cut-resistant-impact-mechanic-gloves-502876.jpg?v=1734301545",
      "alt": "12 pairs Seibertron S - Flexible 06 TPR Oilfield Safety Work Construction Industrial Protective Anti Cut Resistant Impact Mechanic Gloves - Seibertron"
    },
    {
      "id": "28937815752894",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/12-pairs-seibertron-s-flexible-06-tpr-oilfield-safety-work-safety-gloves-construction-industrial-protective-anti-cut-resistant-impact-mechanic-gloves-499595.png?v=1734301545",
      "alt": "12 pairs Seibertron S - Flexible 06 TPR Oilfield Safety Work Safety Gloves Construction Industrial Protective Anti Cut Resistant Impact Mechanic Gloves - Seibertron"
    }
  ],
  "variants": [
    {
      "id": "42595602104510",
      "title": "M",
      "availableForSale": true,
      "options": [
        {
          "name": "Size",
          "value": "M"
        }
      ],
      "values": [
        "M"
      ],
      "mediaId": "28647129809086"
    },
    {
      "id": "42595602137278",
      "title": "L",
      "availableForSale": true,
      "options": [
        {
          "name": "Size",
          "value": "L"
        }
      ],
      "values": [
        "L"
      ],
      "mediaId": "28647129809086"
    },
    {
      "id": "42595602170046",
      "title": "XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Size",
          "value": "XL"
        }
      ],
      "values": [
        "XL"
      ],
      "mediaId": "28647129809086"
    },
    {
      "id": "42595602202814",
      "title": "XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Size",
          "value": "XXL"
        }
      ],
      "values": [
        "XXL"
      ],
      "mediaId": "28647129809086"
    }
  ],
  "singleVariant": false,
  "colorSwatches": {},
  "optimizeColorSwatches": false
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var selectedColor = scope.querySelector('input[name="options[Color]"]:checked');
    var exactColorMediaId = selectedColor && config.colorSwatches ? config.colorSwatches[selectedColor.value] : '';
    if (exactColorMediaId) {
      var exactColorEntry = config.entries.find(function (entry) { return entry.id === exactColorMediaId; });
      if (exactColorEntry) return exactColorEntry;
    }
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncVisualChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name^="options["]');
      if (!input) return;
      var optionMatch = String(input.name || '').match(/^options\[(.+)\]$/);
      if (!optionMatch) return;
      var optionName = optionMatch[1];
      var exactColorMediaId = optionName === 'Color' && config.colorSwatches ? config.colorSwatches[input.value] : '';
      var mediaIds = exactColorMediaId ? [exactColorMediaId] : config.variants.filter(function (variant) {
        return (variant.options || []).some(function (option) {
          return option.name === optionName && option.value === input.value;
        });
      }).map(function (variant) { return variant.mediaId; }).filter(Boolean).filter(function (id, index, all) {
        return all.indexOf(id) === index;
      });
      if (mediaIds.length !== 1) return;
      var entry = config.entries.find(function (item) { return item.id === mediaIds[0]; });
      if (!entry) return;
      var swatch = choice.querySelector('.auto-product__swatch-image');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'auto-product__swatch-image';
        swatch.setAttribute('aria-label', input.value || entry.alt || '');
        (choice.querySelector('[data-auto-choice-label]') || choice).appendChild(swatch);
      }
      var image = swatch.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.width = 72;
        image.height = 72;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      image.src = sized(entry.src, 180);
      image.srcset = '';
      image.alt = input.value || entry.alt || '';
      choice.setAttribute('data-variant-media-id', entry.id);
    });
  }
  function ensureScopedStyles(scope) {
    if (!config.optimizeColorSwatches || document.getElementById('sps5-gallery-swatch-layout-20260716')) return;
    var style = document.createElement('style');
    style.id = 'sps5-gallery-swatch-layout-20260716';
    style.textContent = [
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumbs{display:flex!important;visibility:visible!important;opacity:1!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumb{display:grid!important;visibility:visible!important;opacity:1!important;flex:0 0 auto;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{display:grid!important;grid-template-columns:repeat(6,minmax(58px,1fr));gap:10px;width:100%;overflow:visible;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual{width:100%;min-width:0;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual>[data-auto-choice-label]{width:100%!important;min-width:0!important;height:auto!important;min-height:0!important;aspect-ratio:1/1;display:flex!important;align-items:center!important;justify-content:center!important;overflow:hidden!important;background:#fff!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image,.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{width:100%!important;height:100%!important;display:block!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{object-fit:contain!important;object-position:center!important;background:#fff!important;padding:3px!important;box-sizing:border-box!important;}',
      '@media(max-width:640px){.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{grid-template-columns:repeat(3,minmax(64px,1fr));gap:10px;}}'
    ].join('');
    document.head.appendChild(style);
  }
  function syncSingleVariantLegend(scope) {
    if (!config.singleVariant) return;
    scope.querySelectorAll('.auto-product__option legend').forEach(function (legend) {
      legend.style.setProperty('justify-content', 'flex-start', 'important');
      legend.style.setProperty('align-items', 'center', 'important');
      legend.style.setProperty('gap', '16px', 'important');
      legend.style.setProperty('width', 'fit-content', 'important');
      legend.style.setProperty('max-width', '100%', 'important');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    var desiredSafeIds = '|' + config.entries.map(function (entry) { return entry.id; }).join('|') + '|';
    if (scope.getAttribute('data-safe-gallery-media-ids') !== desiredSafeIds) {
      scope.setAttribute('data-safe-gallery-media-ids', desiredSafeIds);
    }
    ensureScopedStyles(scope);
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.hidden = false;
      thumb.style.display = '';
      thumb.setAttribute('aria-hidden', 'false');
    });
    syncVisualChoices(scope);
    syncSingleVariantLegend(scope);
    syncPurchase(scope);
    setMain(scope, selectedEntry(scope));
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) { return record.addedNodes.length || record.removedNodes.length; });
      if (changed) window.setTimeout(hydrate, 20);
    });
    observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-safe-gallery-media-ids'] });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
  window.setInterval(hydrate, 1200);
})();
// END motorbikeBackpackGalleryRestore20260716
